import CryptoJS from 'crypto-js'

const key = process.env.VUE_APP_AES_KEY;
const iv = process.env.VUE_APP_AES_IV;
/**
 * @data 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 */
export function aesEncrypt(data) {
  if (typeof data === "object") {
    // 如果传入的data是json对象，先转义为json字符串
    try {
      data = JSON.stringify(data)
    } catch (error) {
      console.log("error:", error)
    }
  }
  console.log(data);
  // 统一将传入的字符串转成UTF8编码
  const dataHex = CryptoJS.enc.Utf8.parse(data) // 需要加密的数据
  const keyHex = CryptoJS.enc.Utf8.parse(key) // 秘钥
  const encrypted = CryptoJS.AES.encrypt(dataHex, keyHex, {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC, // 加密模式
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext) //  返回加密后的值
}


/**
 * @word 要解密的内容
 * @keyWord String  服务器随机返回的关键字
 */
export function aesDecrypt(word, keyWord = '54db88ac59ab43c2be1eba0b75bce449') {
  let base64  = CryptoJS.enc.Base64.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(base64);
  const key = CryptoJS.enc.Utf8.parse(keyWord)
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: CryptoJS.enc.Utf8.parse("1234567890000000"),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr;
}

/**
 * 获得 Vue 应用的访问路径
 *
 * @param path 路径
 */
export function getPath(path) {
  // 基础路径，必须以 / 结尾
  let basePath = '/';
  if (!basePath.endsWith('/')) {
    return basePath + '/';
  }
  // 访问路径，必须不能以 / 开头
  if (path.startsWith('/')) {
    path = path.substring(1);
  }
  return basePath + path;
}
